import { addDays, isAfter, isValid } from 'date-fns';

const FUND_LOCK_WINDOW_DAYS = 7;

type ShouldAuthorizePayableAmountArgs = {
  drawCloseAt?: string | null;
  preOrder: boolean;
};

export const shouldAuthorizePayableAmount = ({
  drawCloseAt,
  preOrder,
}: ShouldAuthorizePayableAmountArgs): boolean => {
  if (preOrder || !drawCloseAt) {
    return true;
  }

  const closeAt = new Date(drawCloseAt);

  if (!isValid(closeAt)) {
    return true;
  }

  return !isAfter(closeAt, addDays(new Date(), FUND_LOCK_WINDOW_DAYS));
};
